import { BaseCustomElement } from "brut-js"

class OpenDetails extends BaseCustomElement {
  static tagName = "cc-open-details"

  static observedAttributes = [
    "show-warnings",
    "details",
  ]

  #detailsElementId = null

  #clickListener = (event) => {
    event.preventDefault()
    const detailsElement = this.#locateDetails()
    if (!detailsElement) {
      return // Assume logger has been used in #locateDetails
    }
    if (detailsElement.getAttribute("open") !== null) {
      detailsElement.removeAttribute("open")
    }
    else {
      detailsElement.setAttribute("open","")
    }
  }


  detailsChangedCallback({newValue}) {
    this.#detailsElementId = newValue
  }


  update() {
    let foundSomething = false
    this.querySelectorAll("a").forEach( (child) => {
      child.addEventListener("click", this.#clickListener) 
      foundSomething = true
    })
    this.querySelectorAll("button").forEach( (child) => {
      child.addEventListener("click", this.#clickListener) 
      foundSomething = true
    })
    if (!foundSomething) {
      this.logger.info("Did not find any; <a> or <button> elements - cannot listen for clicks")
    }
  }

  #locateDetails() {
    let detailsElement
    if (this.#detailsElementId) {
      detailsElement = document.getElementById(this.#detailsElementId)
      if (!detailsElement) {
        this.logger.info("No element with ID '%s' - not able to open it",this.#detailsElementId)
        return null
      }
      if (detailsElement.tagName != "DETAILS") {
        this.logger.info("Element with ID '%s' was a %s, not a DETAILS",this.#detailsElementId,detailsElement.tagName)
        return null
      }
    }
    else {
      detailsElement = this.closest("details")
    }
    return detailsElement
  }
}
export default OpenDetails
